<template>
  <v-row>
    <v-col cols="6" offset="3" md="3" offset-md="3">
      <form @submit.prevent="save">
        <v-text-field
          v-model="form.value"
          label="Stopnja"
          suffix="%"
        ></v-text-field>
        <v-btn type="submit" class="float-right">Shrani</v-btn>
        <v-btn text type="button" class="float-right mr-4" @click="$router.go(-1)">Prekliči</v-btn>
      </form>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    taxLevel: {
      default: () => {},
      type: Object
    }
  },
  data () {
    return {
      form: {
        value: null
      }
    }
  },
  methods: {
    save () {
      this.$emit('save', { data: this.form })
    },
    cancel () {
      this.$emit('cancel')
    }
  },
  created () {
    this.form = { ...this.form, ...this.taxLevel }
  }
}
</script>
